import { configureStore } from '@reduxjs/toolkit';
import { flwOrchestratorApi } from './services/flwOrchestratorApi';

export const store = configureStore({
  reducer: {
    [flwOrchestratorApi.reducerPath]: flwOrchestratorApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(flwOrchestratorApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;